<!-- 会员兑换 -->
<template>
  <div class='vipExchange'>
    <publicHeader :pageTitle="pageTitle" isWhite='true'></publicHeader>
    <div class="zhanwei">

    </div>
    <!-- 兑换 -->
    <div class="exchangeBox">
      <div class="code">
        <input type="text" placeholder="请输入兑换码" v-model="code">
      </div>
      <div class="account">
        <div class="word">
          <div class="info1">会员兑换到的账号：{{account}}</div>
          <!-- <div class="change">更换账号</div> -->
        </div>
      </div>
      <div class="exchangeBtn" @click="handleExchange">
        立即兑换
      </div>
    </div>
    <!-- 兑换说明 -->
    <div class="echangeInfo">
      <div class="title">兑换说明</div>
      <div class="desc">
        1、兑换成功后立即开通会员，享受相应的会员权益。<br>
        2、联合会员兑换码，兑换成功后，享受联合会员相应的会员权益。<br>
        3、已是某类会员的用户，此次兑换该类会员，其时长将相应累加。<br>
        4、兑换过程中如有疑问请联系客服，客服电话或者在线QQ为：400-801-5553。<br>
        5、中国体育会员兑换最终解释权归中国体育所有。
      </div>
    </div>
    <span class="toast" v-if="toastIsShow" @changeToast="showToast">{{toastInfo}}</span>
    <publicExchange v-if="showConfirmExchange" :userInfo="userInfo" :code="code" :carmiValue="carmiValue" :token="token" @showDialog="showExchangeMark" @changeToast="showToast"></publicExchange>
    <publicCarmi v-if="isShowUbiteCarmi" @changeShow='showDialog' @changeToast="showToast" :code="code"></publicCarmi>
    <publicDialog :info="info" :title="title" :btn1="btn1" :btn2="btn2" @changeShow='showDialog' :dialogIsShow='dialogIsShow' v-show='dialogIsShow'></publicDialog>
    <publicExSucces v-if="isShowSuccesDialog" :userInfo="userInfo" :succesInfo="succesInfo" @showDialog="showSuccesDialog" :token="token"></publicExSucces>
  </div>

</template>

<script>
import publicDialog from '../components/PublicDialog'
import publicHeader from '../components/PublicHeader'
import publicCarmi from '../components/publicCarmi'
import publicExchange from '../components/publicExchange'
import publicExSucces from '../components/publicExSucces'

export default {
  components: { publicDialog, publicHeader, publicCarmi, publicExchange, publicExSucces },
  data () {
    return {
      // dialog的提示内容
      dialogIsShow: false,
      info: '',
      title: "",
      btn1: "",
      btn2: '我知道了',
      // 兑换码
      code: '',
      // 兑换的账号
      account: '',
      // 兑换码正误
      codeTrue: true,
      pageTitle: '',
      token: '',
      isShowUbiteCarmi: false,
      toastIsShow: false,
      toastInfo: '',
      showConfirmExchange: false,
      carmiValue: '',
      isShowSuccesDialog: false,
      userInfo: {},
      succesInfo: []
    }
  },
  created () {
    this.getToken()
    this.getUserInfo()
    this.account = this.$route.query.userName
    console.log(this.account, 'this.account')
    document.title = "会员兑换码"
    this.pageTitle = '会员兑换码'
    this.changeAppTitle('会员兑换码')
  },
  methods: {
    // 获取url上的信息
    getcommit (name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || ["", ""])[1].replace(/\+/g, "%20")
        ) || false
      );
    },
    // 获取手机号
    getUserInfo() {
      let params = {
        statistics: this.$CONFIG.statistics,
        token: this.token
      }
      this.$vipapi.getVipMine(params).then(res => {
        this.userInfo = Array.isArray(res.data.data.userInfo) ? {} : res.data.data.userInfo
      })
    },
    // 获取token
    getToken () {
      if (this.$CONFIG.isVerify && this.isIOS) {
        this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
      } else {
        this.token = this.getcommit('token') || ''
      }
      console.log(this.token);
    },
    // 处理兑换
    handleExchange () {
      console.log(this.token)
      if (this.code.length === 0) {
        // 兑换码为空
        this.title = '提示'
        this.info = '兑换码不能为空，请输入兑换码'
        this.showDialog(true)
      }
      else if (!this.token && this.code.length === 12) {
        // 登录
        this.phoneLogin()
      } else if ((!this.token || !this.userInfo.userMobile) && this.code.length === 13) {
        // 登录
        this.uniteLogin()
      } else if (this.code.length === 13) {
        this.isShowUbiteCarmi = true
      } else {
        let params = {
          token: this.token,
          code: this.code
        }
        this.$vipapi.vipExchange(params).then(res => {
          if (res.data.status === '200') {
            this.title = '兑换成功'
            this.info = `您的${res.data.data.vname}会员到期时间为${res.data.data.deadline}`
          } else {
            this.title = '提示'
            this.info = res.data.data
          }
          this.showDialog(true)
        })
        // if (!this.codeTrue) {
        //   // 兑换码有误
        //   this.title = '提示'
        //   this.info = '您输入的兑换码有误，请重新输入'
        // }
        // else if (this.codeTrue) {
        //   // 兑换码正确
        //   this.title = '兑换成功'
        //   this.info = this.successInfo
        // }

      }

    },
    // 两端的登录方法
    phoneLogin () {
      // 安卓登录
      try {
        window.LiveAppJS.login();
      } catch (e) {
        console.log('error')
      }
      // IOS登录
      try {
        window.webkit.messageHandlers.isnotlogin.postMessage('login');
      } catch (e) {
        console.log('error')
      }

    },
    // 联合会员登录/绑定
    uniteLogin() {
      if (!this.userInfo.userMobile && this.judgeversion()) {
        this.showToast('请下载新版本购买联合会员')
      } else {
        // 安卓登录
        try {
          let key = this.token && !this.userInfo.userMobile ? "bindMobile" : "mobileLogin"
          let query = JSON.stringify({"command": key})
          window.LiveAppJS.nativeAction(query)
        } catch (e) {
          console.log('login error1111')
        }
        // IOS登录
        try {
          let key = this.token && !this.userInfo.userMobile ? "jumpBindPhonePage" : "phonelogin"
          window.webkit.messageHandlers[key].postMessage("");
        } catch (e) {
          console.log('login error')
        }
      }
    },
    // 判断版本号
    judgeversion() {
      // 判断时候版本号，安卓小于5.4.3，IOS小于5.4.2的版本显示toast(请下载最新版本)
      const category = decodeURI(this.$CONFIG.statistics) || ''
      let version = this.$CONFIG.isIOS ? category.split('|')[category.split('|').length - 1] : category.split('|')[7]
      if (this.$CONFIG.isIOS) {
        return version < '5.4.2' ? true : false
      } else {
        return version < '5.4.3' ? true : false
      }
    },
    showDialog (visible, val) {
      if (visible === 'carmi') {
        this.isShowUbiteCarmi = false
      } else if (visible === 'confirm') {
        this.isShowUbiteCarmi = false
        this.carmiValue = val
        this.showConfirmExchange = true
      } else {
        this.dialogIsShow = visible
      }
    },
    showExchangeMark(val, data) {
      if (val === 'succes') {
        this.succesInfo = data
        this.showSuccesDialog()
      }
      this.showConfirmExchange = false
    },
    // 兑换成功弹框
    showSuccesDialog() {
      console.log(1111111)
      this.code = ''
      this.isShowSuccesDialog = !this.isShowSuccesDialog
    },
    showToast(val) {
      this.toastInfo = val
      this.toastIsShow = true
      setTimeout(() => {
        this.toastIsShow = false
      }, 2000)
    },
    // 修改两端标题
    changeAppTitle (newtitle) {
      try {
        window.webkit.messageHandlers.changeTitle.postMessage(newtitle)
      } catch (e) {
        console.log('IOS修改标题', newtitle)
      }
      try {
        window.LiveAppJS.changeTitle(newtitle)
      } catch (e) {
        console.log("安卓修改标题", newtitle)
      }
    }
  },
}
</script>
<style lang='less' scoped>
.vipExchange {
  width: 100vw;
  height: 100vh;
  background: #f2f2f2;
  box-sizing: border-box;

  .exchangeBox {
    // width: 100%;
    height: 4.12rem;
    box-sizing: border-box;
    margin: 0.3rem;
    padding: .3rem 0.3rem 0.4rem 0.3rem;
    margin-bottom: 0;
    background: #ffffff;
    border-radius: 0.1rem;
    display: flex;
    flex-direction: column;
    // 兑换码输入框
    .code {
      height: 0.96rem;
      width: 100%;
      padding-bottom: 0.01rem;
      border-bottom: 0.14vw solid #e5e5e5;
      input {
        display: block;
        width: 100%;
        height: 100%;
        font-size: 0.28rem;
        letter-spacing: 1px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        // background: chartreuse;
        &::-webkit-input-placeholder {
          // background: red;
          font-size: 0.28rem;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 100;
          color: #999999;
          // line-height: 0.4rem;
          display: flex;
          justify-content: center;
          align-items: baseline;
          // line-height: 1;
          line-height: 0.4rem;
          margin-top: 0.1rem;
        }
      }
    }
    // 账号信息
    .account {
      margin: .2rem 0 1.13rem 0;
      .word {
        display: flex;
        justify-content: space-between;
        // margin-bottom: 0.1rem;
        .info1 {
          font-size: .24rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: .33rem;
        }
        .change {
          font-size: 0.28rem;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #ff4a4a;
        }
      }
      .name {
        text-align: left;
        margin-bottom: 0.2rem;
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 0.4rem;
      }
    }
    // 兑换按钮
    .exchangeBtn {
      width: 100%;
      height: 0.8rem;
      border-radius: 0.45rem;

      background: linear-gradient(145deg, #f5e4d3 0%, #c4a485 100%);
      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 0.28rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #613f25;
    }
  }
  // 兑换说明
  .echangeInfo {
    padding: 0 0.3rem 0.3rem 0.3rem;
    .title {
      text-align: left;
      padding: 0.3rem 0 0.1rem 0;

      font-size: 0.28rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    .desc {
      text-align: left;
      font-size: 0.28rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 0.44rem;
    }
  }
  .toast {
    z-index: 30;
    display: inline-block;
    white-space: nowrap;
    height: 20px;
    position: fixed;
    margin: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.8);
    border-radius: 4px;
    padding: 10px 20px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: rgba(255, 255, 255, 1);
    text-align: center;
  }
}
</style>